import { Button, Form } from 'antd';
import styled from 'styled-components';

export const WrapContainer = styled.div`
  background-color: white;
  margin: 10px 50px;
  padding: 25px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`;

export const HeaderWrap = styled.div`
  text-align: center;
  margin-top: 24px;
`;

export const Header = styled.h3`
  margin: 0;
`;

export const BodyWrap = styled.div``;

export const ContentWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SubHeaderWrap = styled.div`
  text-align: center;
  margin-top: 24px;
`;

export const SubHeader = styled.div`
  font-weight: bold;
`;

export const FormContainer = styled.div`
  .ant-form-item-control-input {
    width: 250px;
  }
  margin-top: 24px;
`;

export const FormColWrap = styled.div`
  display: grid;
  justify-items: end;
  @media (max-width: 574px) {
    justify-items: start;
    max-width: min-content;
    width: 100%;
  }
`;

export const FormItemWrap = styled(Form.Item)`
  max-width: 400px;
  width: 100%;
  display: flex;
  justify-content: end;
  @media (max-width: 575px) {
    justify-content: start;
  }
`;

export const StyledButton = styled(Button)`
  width: 250px;
`;
